import React from 'react'
import Layout from 'features/layout/components/Layout'
import PeopleForm from '../components/PeopleForm'

const PeopleFormPage = (props) => {
  return (
    <Layout>
      <PeopleForm />
    </Layout>
  )
}

export default PeopleFormPage
